import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Arunika',
    description: 'Dasbor SaaS untuk memantau MRR, pelanggan, langganan, dan pertumbuhan bisnis Anda dalam satu layar.',
    placeholder: 'Arunika membantu Anda membaca kesehatan bisnis langganan setiap hari.',
    url: getOrigin()
}
